import { Component, OnInit, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from "../../security/auth.service";
import { ValidationService } from '../../shared/validation/validation.service';
import { AppConfig, APP_CONFIG } from '../../shared/app-config.module';
import { LanguageService } from '../../shared/language/language.service';
import { AlertService } from '../../shared/alert/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { IApplicationConfiguration } from '../../models/IApplicatinConfiguration';
import { ICompany } from '../../models/ICompany';
import { finalize } from 'rxjs/operators';


@Component({
  templateUrl: './renewal.component.html',
  styleUrls: ['./renewal.style.css']
})

export class RenewalComponent implements OnInit {
  model: any = {};
  loading = false;
  returnUrl: string;
  renewalTokenForm: FormGroup;
  submitted = false;
  pUsername: string;
  pLanguage: string;
  pAccessToken: string;
  pServerInstance: string;
  passwrodLength: number;
  showLogin: boolean = false;
  configuration: IApplicationConfiguration;
  filteredCompanies: ICompany[];
  regexUrl = ".*"  //Needed (ngPattern surrounds with ^ and $)
    + "(?=^.{6,}$)"       //At least 6 Characters
    + "(?=[^\\d]*\\d)"    //At least one digit
    + "(?=[^\\W]*\\W)"    //At least one special character
    + "(?=[^A-Z]*[A-Z])"  //At least one uppercase character
    + "(?=[^a-z]*[a-z])"  //At least one lowercase character
    + ".*";    //Needed (ngPattern surrounds with ^ and $)

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private validationService: ValidationService,
    private formBuilder: FormBuilder,
    public languageService: LanguageService,
    private alertService: AlertService,
    private translateService: TranslateService,
    @Inject(APP_CONFIG) config: AppConfig) {

    this.passwrodLength = config.passwordLength;
    this.route.queryParams.subscribe(params => {
      this.pLanguage = params['lang'];
      this.pUsername = params['username'];
      this.pAccessToken = params['token'];
      this.pServerInstance = params['serverinstance'];
    });

    this.languageService.useLanguage(this.pLanguage);

    var configuration = localStorage.getItem(config.storageApplicationConfiguration);
    if (configuration != null && configuration != "")
      this.configuration = JSON.parse(configuration);
    else
      this.configuration = <IApplicationConfiguration>{};
  }

  ngOnInit() {

    if (this.pServerInstance != undefined && this.pServerInstance != null && this.pServerInstance != "")
      this.configuration.serverInstance = this.pServerInstance;

    this.renewalTokenForm = this.formBuilder.group({
      id: [''],
      Username: [this.pUsername, Validators.required],
      Password: ['', [Validators.required, Validators.minLength(this.passwrodLength)]],
      ConfirmPassword: ['', [Validators.required, Validators.minLength(this.passwrodLength)]],
      AccessToken: [this.pAccessToken, [Validators.required]],
      Language: [this.pLanguage, [Validators.required]],
      serverInstance: [this.configuration.serverInstance, [Validators.required, Validators.pattern(this.regexUrl)]],
      companyName: [this.configuration.companyName, Validators.required],
    }, {
      validator: [
        ValidationService.match('Password', 'ConfirmPassword')
      ]
    });

    // reset login status
    this.authService.logout();
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';
  }

  onSubmit(model) {
    this.submitted = true;
    this.renewalTokenForm.controls['id'].updateValueAndValidity();
    if (this.renewalTokenForm.invalid) {
      return;
    }
    this.renewalToken(model);
  }

  renewalToken(model) {
    this.loading = true;
    this.authService.renewalToken(model.value)
      .subscribe(
        data => {
          this.alertService.success(this.translateService.instant('CHOSEPASSWORD_SUCCESFULLY'));
          this.showLogin = true;
          //this.router.navigate(['login']);
        },
        error => {
          let obj = JSON.parse(error._body);
          this.validationService.mapValidationServerMessage(obj, this.renewalTokenForm);
          this.loading = false;
        });
  }

  goToLogin() {
    this.router.navigate(['login']);
  }

  onChangeServerInstance() {
    this.renewalTokenForm.controls.companyName.setValue('');
    this.filteredCompanies = [];
  }


  onFocusCompanyName() {
    this.lookupCompanyName();
  }

  lookupCompanyName() {
    this.alertService.clear();
    this.loading = true;
    var serverInstance = this.renewalTokenForm.controls.serverInstance.value;
    return this.authService.loadCompanies(serverInstance)
      .pipe(
        finalize(() => {
          this.loading = false;
        }))
      .subscribe((results) => {
        this.filteredCompanies = results;
      }, (error) => {
        var err = error.json();
        this.alertService.error(err.message);
      });
  }
}
